import config from '@/Framework/config';
import finsightConfig from '@finsight/config';
import dataroomConfig from '@dataroom/config';

import HonKong from '@/finsight/ui/components/static/Company/ContactUs/assets/HonKong.webp';
import Kyiv from '@/finsight/ui/components/static/Company/ContactUs/assets/Kyiv.webp';
import London from '@/finsight/ui/components/static/Company/ContactUs/assets/London.webp';
import Miami from '@/finsight/ui/components/static/Company/ContactUs/assets/Miami.webp';
import NY from '@/finsight/ui/components/static/Company/ContactUs/assets/NY(HQ).webp';
import Singapore from '@/finsight/ui/components/static/Company/ContactUs/assets/Singapore.webp';
import Toronto from '@/finsight/ui/components/static/Company/ContactUs/assets/Toronto.webp';
import Manila from '@/finsight/ui/components/static/Company/ContactUs/assets/Manila.webp';

import asiaPacific from '@/finsight/ui/components/static/Company/ContactUs/assets/asiaPacific.webp';
import europe from '@/finsight/ui/components/static/Company/ContactUs/assets/europe.webp';
import latinAmerica from '@/finsight/ui/components/static/Company/ContactUs/assets/latinAmerica.webp';
import USA from '@/finsight/ui/components/static/Company/ContactUs/assets/USA.webp';

import offices from './Offices/offices.scss';


export const OFFICE_LIST = [
  {
    photo: HonKong,
    name: 'Hong Kong',
    address: ['Finsight HK Ltd', 'Hong Kong, SAR']
  },
  {
    photo: Kyiv,
    name: 'Kyiv',
    address: ['Finsight Ukraine LLC', 'Kyiv, Ukraine']
  },
  {
    photo: London,
    name: 'London',
    address: ['Finsight UK Ltd', 'London, UK']
  },
  {
    photo: Miami,
    name: 'Miami',
    address: ['Finsight Group Inc']
  },
  {
    photo: NY,
    name: 'New York',
    address: ['Finsight Group Inc', '530 7th Ave, 27th Fl New York, NY 10018']
  },
  {
    photo: Singapore,
    name: 'Singapore',
    address: ['Finsight SG Pte Ltd']
  },
  {
    photo: Toronto,
    name: 'Toronto',
    address: ['Finsight Group Inc']
  },
  {
    photo: Manila,
    name: 'Manila',
    address: ['Finsight Group Inc']
  }
];

export const EMAILS = {
  products: [
    {
      title: 'CapEdge',
      value: 'support@capedge.com'
    },
    {
      title: 'Deal Roadshow',
      value: config.tenant.dealroadshow.supportEmail
    },
    {
      title: 'DealVDR',
      value: dataroomConfig.tenant.tenantDealvdr.supportEmail
    },
    {
      title: 'Evercall',
      value: config.tenant.tenantEvercall.supportEmail
    },
    {
      title: 'Finsight.com',
      value: finsightConfig.supportEmail
    },
    {
      title: 'InvestorSet',
      value: dataroomConfig.tenant.tenantInvestorSet.supportEmail
    },
    {
      title: 'VeriSend',
      value: dataroomConfig.tenant.tenantVeriSend.supportEmail
    },
    {
      title: '17g5.com',
      value: dataroomConfig.tenant.tenant17g5.supportEmail
    }
  ],
  topics: [
    {
      title: 'Billing',
      value: 'billing@finsight.com'
    },
    {
      title: 'Careers',
      value: 'careers@finsight.com'
    },
    {
      title: 'Media',
      value: 'media@finsight.com'
    },
    {
      title: 'Sales',
      value: 'sales@finsight.com'
    },
    {
      title: 'Legal',
      value: 'legal@finsight.com'
    }
  ]
};

export const PHONE_LIST = [
  {
    icon: asiaPacific,
    title: 'Asia Pacific',
    value: '+852 3018-1600'
  },
  {
    icon: europe,
    title: 'Europe, Middle East & Africa',
    value: '+44 808-178-7364'
  },
  {
    icon: latinAmerica,
    title: 'Latin America',
    value: '+55 21-3958-8827'
  },
  {
    icon: USA,
    title: 'United States & Canada',
    value: '+1 888-997-6610'
  }
];

export const officesSliderSettings = {
  className: offices.officesSlider,
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  initialSlide: 0,
  slidesToScroll: 1,
  autoplay: true,
  centerMode: true,
  centerPadding: '198px',
  autoplaySpeed: 5000,
  cssEase: 'linear',
  pauseOnHover: true,
  swipeToSlide: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 3,
        centerPadding: '30px',
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        centerPadding: '80px',
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        centerMode: false,
      }
    }
  ]
};
